import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { IconButton, makeStyles } from "@material-ui/core";
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import { RotateLeft, RotateRight, ZoomIn, ZoomOut } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  navWrapper: {
    width: "100%",
    padding: "5px 0",
    backgroundColor: theme.palette.secondary.dark,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  btn: {
    margin: "0 2px",
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.primary.main,
    padding: 2,
    "&:hover": {
      color: theme.palette.secondary.light,
      backgroundColor: theme.palette.primary.main,
    },
  },
  pageNum: {
    margin: 0,
    fontWeight: 500,
    fontSize: 14,
    margin: "0 10px",
  },
  btnGrp: {
    margin: "10px 0",
    display: "flex",
    alignItems: "center",
  },
}));

export const CustomZoomInButton = (props) => {
  const { scale, maxScale, handleZoomIn } = props;
  const classes = useStyles();

  return (
    <IconButton
      disables={scale === maxScale}
      onClick={handleZoomIn}
      className={classes.btn}
    >
      <ZoomIn />
    </IconButton>
  );
};
export const CustomZoomOutButton = (props) => {
  const { scale, minScale, handleZoomOut } = props;
  const classes = useStyles();

  return (
    <IconButton
      disables={scale === minScale}
      onClick={handleZoomOut}
      className={classes.btn}
    >
      <ZoomOut />
    </IconButton>
  );
};
export const CustomPrevButton = (props) => {
  const { page, handlePrevClick } = props;
  const classes = useStyles();

  return (
    <IconButton
      disabled={page === 1}
      className={classes.btn}
      onClick={handlePrevClick}
    >
      <MdNavigateBefore />
    </IconButton>
  );
};
CustomPrevButton.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  handlePrevClick: PropTypes.func.isRequired,
};

export const CustomNextButton = (props) => {
  const { page, pages, handleNextClick } = props;
  const classes = useStyles();

  return (
    <IconButton
      disabled={page === pages}
      className={classes.btn}
      onClick={handleNextClick}
    >
      <MdNavigateNext />
    </IconButton>
  );
};
CustomNextButton.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  handleNextClick: PropTypes.func.isRequired,
};

export const CustomPages = (props) => {
  const { page, pages } = props;
  const classes = useStyles();
  return (
    <h3 className={classes.pageNum}>
      Page {page} from {pages}
    </h3>
  );
};
CustomPages.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
};

export const CustomRotateLeft = (props) => {
  const { rotation, handleRotateLeft } = props;
  const classes = useStyles();

  return (
    <IconButton className={classes.btn} onClick={handleRotateLeft}>
      <RotateLeft />
    </IconButton>
  );
};

export const CustomRotateRight = (props) => {
  const { rotation, handleRotateRight } = props;
  const classes = useStyles();

  return (
    <IconButton className={classes.btn} onClick={handleRotateRight}>
      <RotateRight />
    </IconButton>
  );
};
const CustomNavigation = (props) => {
  const { page, pages, scale, minScale, maxScale, rotationAngle } = props;
  const classes = useStyles();

  const { handleZoomIn, handleZoomOut } = props;
  const { handleNextClick, handlePrevClick } = props;
  const { handleRotateLeft, handleRotateRight } = props;
  return (
    <div className={classes.navWrapper}>
      <div className={classes.btnGrp}>
        <CustomZoomInButton
          scale={scale}
          maxScale={maxScale}
          handleZoomIn={handleZoomIn}
        />
        {/* <CustomZoomOutButton scale={scale} minScale={minScale} handleZoomOut={handleZoomOut} /> */}
      </div>
      <div className={classes.btnGrp}>
        <CustomPrevButton
          page={page}
          pages={pages}
          handlePrevClick={handlePrevClick}
        />
        <CustomPages page={page} pages={pages} />
        <CustomNextButton
          page={page}
          pages={pages}
          handleNextClick={handleNextClick}
        />
      </div>
      <div className={classes.btnGrp}>
        {/* <CustomZoomInButton scale={scale} maxScale={maxScale} handleZoomIn={handleZoomIn} /> */}
        <CustomZoomOutButton
          scale={scale}
          minScale={minScale}
          handleZoomOut={handleZoomOut}
        />
      </div>
    </div>
  );
};
CustomNavigation.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  handlePrevClick: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
};

export default CustomNavigation;
